module.exports = __webpack_public_path__ + "img/Heilongjiang-power.3575c9c9.png";